module.exports = {
  animationTextData: () => {
    return{
      "IONIQ 5 EV-POWER": [
        [
          {
            "duration": 3900,
            "texts": [
              {
                "class": "text-title",
                "text": "IONIQ 5"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "EV-POWER"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title",
                "text": "RINES"
              },
              {
                "class": "text-subtext",
                "text": "Bitono con diseño fractal"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title",
                "text": "FAROLAS DELANTERAS"
              },
              {
                "class": "text-subtext",
                "text": "Con diseño de Píxel, minimal y futurista"
              }
            ]
          },
          {
            "duration": 10000,
            "texts": [
            ]
          },
          {
            "duration": 2000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "MATERIALES AMIGABLES"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Con el medio ambiente"
              }
            ]
          },
          {
            "duration": 3000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "CUATRO PUESTOS"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Con cojinería de Cuero Eco-Procesado"
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "TUCSON HEV LIMITED": [
        [
          {
            "duration": 4800,
            "texts": [
              {
                "class": "text-title",
                "text": "TUCSON HEV"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "LIMITED"
              }
            ]
          },
          {
            "duration": 4800,
            "texts": [
              {
                "class": "text-title",
                "text": "RINES DE 19”"
              },
              {
                "class": "text-subtext",
                "text": "CON ALEACIÓN BITONO"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title",
                "text": "SENSORES DE PARQUEO"
              },
              {
                "class": "text-subtext",
                "text": "DELANTEROS Y TRASEROS"
              }
            ]
          },
          {
            "duration": 10000,
            "texts": [
            ]
          },
          {
            "duration": 5000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "TABLERO DE INSTRUMENTOS"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Pantalla Supervisión 12,3” LCD TFT + Reóstato"
              }
            ]
          },
          {
            "duration": 5000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "MATERIAL DE COJINERÍA"
              },
              {
                "class": "text-subtext addbackground",
                "text": "CON CUERO"
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "PALISADE SPORT": [
        [
          {
            "duration": 3900,
            "texts": [
              {
                "class": "text-title",
                "text": "PALISADE"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "SPORT"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title",
                "text": "RINES DE 20”"
              },
              {
                "class": "text-subtext",
                "text": "Con geometrías sencillas pero únicas en aleación bitono"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title",
                "text": "SENSORES DE PARQUEO"
              },
              {
                "class": "text-subtext",
                "text": "Delanteros y traseros"
              }
            ]
          },
          {
            "duration": 10000,
            "texts": [
            ]
          },
          {
            "duration": 2000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "CENTRO DE ENTRETENIMIENTO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Pantalla digital de 12,3” con conexión a Apple CarPlay y Android Auto"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "GRAN CAPACIDAD DE PASAJEROS"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Dispone de 8 asientos para maximizar su utilidad"
              }
            ]
          },
          {
            "duration": 100,
            "texts": [
            ]
          },
        ]
      ],

      "STARIA LUJO": [
        [
          {
            "duration": 3900,
            "texts": [
              {
                "class": "text-title",
                "text": "STARIA"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "LUJO"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title",
                "text": "SUSPENSIÓN"
              },
              {
                "class": "text-subtext",
                "text": "En la parte frontal y posterior"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title",
                "text": "MOTOR R2.2 CRDI"
              },
              {
                "class": "text-subtext",
                "text": "Motor diésel con transmisión de 6 velocidades"
              }
            ]
          },
          {
            "duration": 10000,
            "texts": [
            ]
          },
          {
            "duration": 2000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "CONSOLA MULTIUSOS"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Consola de almacenamiento central plegable que da espacio para un tercer pasajero"
              }
            ]
          },
          {
            "duration": 3000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "Espacio de Carga"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Con puerta corrediza y de cajuela"
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "VENUE LIMITED AT": [
        [
          {
            "duration": 4800,
            "texts": [
              {
                "class": "text-title",
                "text": "VENUE"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "LIMITED"
              }
            ]
          },
          {
            "duration": 4800,
            "texts": [
              {
                "class": "text-title",
                "text": "RINES DE LUJO"
              },
              {
                "class": "text-subtext",
                "text": "Aleación de 17”"
              }
            ]
          },
          {
            "duration": 10000,
            "texts": [
              {
                "class": "text-title",
                "text": "RIELES DE TECHO"
              },
              {
                "class": "text-subtext",
                "text": "En aluminio, soportan hasta 80 kg"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
            ]
          },
          {
            "duration": 3000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "CENTRO DE ENTRETENIMIENTO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Conectividad de Apple CarPlay y Android Auto"
              }
            ]
          },
          {
            "duration": 3000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "AIRBAGS"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Cuenta con 6 airbags con sensores de detección para cuidar a todos los pasajeros"
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "HB20 ADVANCE": [
        [
          {
            "duration": 4100,
            "texts": [
              {
                "class": "text-title",
                "text": "HB20"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "ADVANCE"
              }
            ]
          },
          {
            "duration": 5700,
            "texts": [
              {
                "class": "text-title",
                "text": "RINES"
              },
              {
                "class": "text-subtext",
                "text": "Aleación bitono de 15”"
              }
            ]
          },
          {
            "duration": 5300,
            "texts": [
              {
                "class": "text-title",
                "text": "ESPEJOS ELÉCTRICOS"
              },
              {
                "class": "text-subtext",
                "text": "Espejos eléctricos del color de la carrocería con direccionales incorporadas."
              }
            ]
          },
          {
            "duration": 8500,
            "texts": [
            ]
          },
          {
            "duration": 5000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "CENTRO DE ENTRETENIMIENTO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Pantalla de 8”. Conectividad de Apple CarPlay y Android Auto. Conectividad Bluetooth, reconocimiento de voz y aire acondicionado"
              }
            ]
          },
          {
            "duration": 3000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "DISEÑO MODERNO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Diseñado para garantizar la comodidad y un gran viaje"
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "HB20S ADVANCE": [
        [
          {
            "duration": 4100,
            "texts": [
              {
                "class": "text-title",
                "text": "HB20S"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "ADVANCE"
              }
            ]
          },
          {
            "duration": 5700,
            "texts": [
              {
                "class": "text-title",
                "text": "RINES"
              },
              {
                "class": "text-subtext",
                "text": "Aleación bitono de 15”"
              }
            ]
          },
          {
            "duration": 5300,
            "texts": [
              {
                "class": "text-title",
                "text": "ESPEJOS ELÉCTRICOS"
              },
              {
                "class": "text-subtext",
                "text": "Espejos eléctricos del color de la carrocería con direccionales incorporadas."
              }
            ]
          },
          {
            "duration": 8500,
            "texts": [
            ]
          },
          {
            "duration": 5000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "CENTRO DE ENTRETENIMIENTO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Pantalla de 8”. Conectividad de Apple CarPlay y Android Auto. Conectividad Bluetooth, reconocimiento de voz y aire acondicionado"
              }
            ]
          },
          {
            "duration": 3000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "DISEÑO MODERNO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Diseñado para garantizar la comodidad y un gran viaje"
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "CRETA PREMIUM": [
        [
          {
            "duration": 3900,
            "texts": [
              {
                "class": "text-title",
                "text": "CRETA"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "PREMIUM"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title",
                "text": "RINES DE LUJO"
              },
              {
                "class": "text-subtext",
                "text": "Aleación de 17”"
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
              {
                "class": "text-title",
                "text": "RIELES DE TECHO"
              },
              {
                "class": "text-subtext",
                "text": "En aluminio, soportan hasta 80 kg"
              }
            ]
          },
          {
            "duration": 10000,
            "texts": [
            ]
          },
          {
            "duration": 2000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "CENTRO DE ENTRETENIMIENTO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Pantalla de 8”. Conectividad de Apple CarPlay y Android Auto. Comando de voz, conectividad Bluetooth y mandos en el timón."
              }
            ]
          },
          {
            "duration": 3000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "AIRBAGS"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Cuenta con 6 airbags con sensores de detección para cuidar a todos los pasajeros (dos airbags frontales, dos airbags laterales y dos airbags de cortina)."
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "KONA HEV LIMITED": [
        [
          {
            "duration": 4400,
            "texts": [
              {
                "class": "text-title",
                "text": "KONA HEV"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "LIMITED"
              }
            ]
          },
          {
            "duration": 5300,
            "texts": [
              {
                "class": "text-title",
                "text": "Rines de 17” y 18”"
              },
              {
                "class": "text-subtext",
                "text": "Dos variaciones disponibles, hechas en aleación con una variante bitono"
              }
            ]
          },
          {
            "duration": 4500,
            "texts": [
              {
                "class": "text-title",
                "text": "RIELES DE TECHO"
              },
              {
                "class": "text-subtext",
                "text": "Dos rieles verticales del color asignado para el techo, complementando su acabado de lujo"
              }
            ]
          },
          {
            "duration": 9500,
            "texts": [
            ]
          },
          {
            "duration": 5000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "PANTALLA CURVA"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Tablero de instrumentos junto al centro de entretenimiento disponible en una pantalla curva horizontal de 12,3”"
              }
            ]
          },
          {
            "duration": 6000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "COJINERÍA DE LUJO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Cómoda e innovadora cojinería compuesta de cuero y eco-cuero"
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "SANTA FE HEV LIMITED 4x4": [
        [
          {
            "duration": 4400,
            "texts": [
              {
                "class": "text-title",
                "text": "SANTA FE"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "LIMITED"
              }
            ]
          },
          {
            "duration": 5300,
            "texts": [
              {
                "class": "text-title",
                "text": "Rines de 20”"
              },
              {
                "class": "text-subtext",
                "text": "Diseño exclusivo en aleación bitono"
              }
            ]
          },
          {
            "duration": 4500,
            "texts": [
              {
                "class": "text-title",
                "text": "RIELES PORTAEQUIPAJE"
              },
              {
                "class": "text-subtext",
                "text": "Brindan estabilidad y seguridad al momento de viajar"
              }
            ]
          },
          {
            "duration": 9500,
            "texts": [
            ]
          },
          {
            "duration": 5000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "PANTALLA CURVA"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Tablero de instrumentos junto al centro de entretenimiento disponible en una pantalla curva horizontal de 12,3”"
              }
            ]
          },
          {
            "duration": 6000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "COJINERÍA DE LUJO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Cómoda e innovadora cojinería compuesta de cuero"
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "GRAND i10 AT PREMIUM": [
        [
          {
            "duration": 4800,
            "texts": [
              {
                "class": "text-title",
                "text": "GRAND i10"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "AT PREMIUM"
              }
            ]
          },
          {
            "duration": 4800,
            "texts": [
              {
                "class": "text-title",
                "text": "RINES"
              },
              {
                "class": "text-subtext",
                "text": "Aleación bitono de 15”"
              }
            ]
          },
          {
            "duration": 10000,
            "texts": [
              {
                "class": "text-title",
                "text": "ESPEJOS ELÉCTRICOS"
              },
              {
                "class": "text-subtext",
                "text": "Espejos eléctricos del color de la carrocería con direccionales incorporadas."
              }
            ]
          },
          {
            "duration": 4000,
            "texts": [
            ]
          },
          {
            "duration": 3000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "CENTRO DE ENTRETENIMIENTO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Pantalla de 8”. Conectividad de Apple CarPlay y Android Auto. Conectividad Bluetooth, reconocimiento de voz y aire acondicionado."
              }
            ]
          },
          {
            "duration": 3000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "DISEÑO MODERNO"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Diseñado para brindarte un viaje cómodo y seguro a cada lugar."
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],

      "PALISADE HEV 4x4": [
        [
          {
            "duration": 4800,
            "texts": [
              {
                "class": "text-title",
                "text": "PALISADE HEV"
              },
              {
                "class": "text-subtext subtext-left",
                "text": "4x4"
              }
            ]
          },
          {
            "duration": 4800,
            "texts": [
              {
                "class": "text-title",
                "text": "RINES"
              },
              {
                "class": "text-subtext",
                "text": "Rines de 20” en aluminio bitono, elegantes e imponentes."
              }
            ]
          },
          {
            "duration": 5000,
            "texts": [
              {
                "class": "text-title",
                "text": "SISTEMA HÍBRIDO "
              },
              {
                "class": "text-subtext",
                "text": "Motor Turbo 2.5 litros con potencia, eficiencia y suavidad."
              }
            ]
          },
          {
            "duration": 9000,
            "texts": [
            ]
          },
          {
            "duration": 6000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "PANTALLA PANORÁMICA"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Panel digital y pantalla multimedia de 12.3”. "
              }
            ]
          },
          {
            "duration": 6000,
            "texts": [
              {
                "class": "text-title addbackground",
                "text": "TRES FILAS DE ASIENTOS"
              },
              {
                "class": "text-subtext addbackground",
                "text": "Interior amplio con tres filas para mayor comodidad. "
              }
            ]
          },
          {
            "duration": 1000,
            "texts": [
            ]
          },
        ]
      ],
      

    }
  }
}